import { RecordInfo } from "./RecordInfo";

export interface RecipientInfo {
  read: boolean;
}

export enum NoteChange {
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  DELETED = "DELETED",
}

export interface ProjectNote {
  id: string;
  note?: string;
  createdBy: RecordInfo;
}
